import React from 'react';
import { DeleteWarning, DomHelpers, Loading, Paging, SystemText } from 'e4shared';
import NoResults from 'components/general/noResults';
import { e4Format } from 'helpers/dates';
import TableSorter from 'components/general/tableSorter';
import TableListHover from 'components/admin/tableListHover';

export const GroupMembership = ({
    data,
    page,
    loading,
    setPage,
    sortBy,
    setSortBy,
    descending,
    setDescending,
    selected,
    onRemove,
    onEdit,
    recordCount,
}) => {
    const formatDate = d => (d ? e4Format(d) : '-');
    const [showDeleteWarning, setShowDeleteWarning] = React.useState(false);

    const sortProps = {
        sortBy,
        descending,
        setSortBy,
        setDescending,
    };

    const handleButtonClick = React.useCallback(
        e => {
            const btn = DomHelpers.getEventButton(e);

            switch (btn.value) {
                case 'edit':
                    const profileGroupId = e.currentTarget.dataset.profilegroupid;
                    onEdit(profileGroupId);
                    break;

                case 'remove':
                    if (confirm(SystemText('Admin/UserGroup/Table/Options/UserGroup/ConfirmRemove'))) {
                        const profileGroupId = e.currentTarget.dataset.profilegroupid;
                        onRemove(profileGroupId);
                        setShowDeleteWarning(false);
                    }

                    break;

                default:
                    break;
            }
        },
        [selected, data]
    );

    return (
        <div key="courses">
            {data?.length > 0 ? (
                <div>
                    {loading ? (
                        <Loading />
                    ) : (
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>
                                        <TableSorter default column="name" {...sortProps}>
                                            {SystemText('Admin/UserGroup/Table/Columns/Name')}
                                        </TableSorter>
                                    </th>
                                    <th>
                                        <TableSorter column="numberOfProfiles" {...sortProps}>
                                            {SystemText('Admin/UserGroup/Table/Columns/NumberOfUsers')}
                                        </TableSorter>
                                    </th>
                                    <th>
                                        <TableSorter column="collectionNames" {...sortProps}>
                                            {SystemText('Admin/UserGroup/Table/Columns/CollectionsAssigned')}
                                        </TableSorter>
                                    </th>
                                    <th>
                                        <TableSorter column="created" {...sortProps}>
                                            {SystemText('Admin/UserGroup/Table/Columns/Created')}
                                        </TableSorter>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.map((profileGroup, i) => {
                                    return (
                                        <tr key={`progress-${profileGroup.id}-${i}`} data-profilegroupid={profileGroup.id}>
                                            <td width="1" className="no-wrap">
                                                {profileGroup.name}
                                            </td>
                                            <td>
                                                <span className="flex felx-center">
                                                    <span>{profileGroup.numberOfProfiles}</span>
                                                </span>
                                            </td>
                                            <td>
                                                {profileGroup.collectionNames &&
                                                profileGroup.collectionNames.some(c => c) ? (
                                                    <TableListHover
                                                        icon="fa-cube"
                                                        data={profileGroup.collectionNames.filter(c => c)}
                                                        uniqueKey={`collection-${profileGroup.collectionNames
                                                            .filter(c => c)
                                                            .map((_, index) => index)
                                                            .join('-')}`}
                                                    />
                                                ) : (
                                                    <span>-</span>
                                                )}
                                            </td>
                                            <td>
                                                <span className="flex felx-center">
                                                    <span>{formatDate(profileGroup.created)}</span>
                                                </span>
                                            </td>
                                            <td className="text-right table-btns">
                                                <button
                                                    title={SystemText('Admin/UserGroup/Table/Options/UserGroup/Update')}
                                                    className="btn btn-primary btn-sm"
                                                    value="edit"
                                                    data-profilegroupid={profileGroup.id}
                                                    onClick={handleButtonClick}
                                                >
                                                    <i className="fa fa-edit" />
                                                </button>

                                                {profileGroup.canBeDeleted && (
                                                    <button
                                                        title={SystemText('Admin/UserGroup/Table/Options/UserGroup/Remove')}
                                                        value="remove"
                                                        data-profilegroupid={profileGroup.id}
                                                        onClick={handleButtonClick}
                                                        className="btn btn-danger btn-sm"
                                                    >
                                                        <i className="fa fa-trash" />
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}

                    {recordCount > 10 && (
                        <div className="text-center mb10 mtm10">
                            <Paging recordCount={recordCount} page={page} goToPage={setPage} pageSize={10} />
                        </div>
                    )}
                </div>
            ) : (
                <NoResults
                    title={SystemText('Admin/UserGroup/NoResults/Title')}
                    message={SystemText('Admin/UserGroup/NoResults/Message')}
                />
            )}
            <DeleteWarning
                message={SystemText('ReviewTracker/Tabs/Reviews/Delete/Warning')}
                show={showDeleteWarning}
                close={confirm => {
                    api.delete(confirm);
                }}
            />
        </div>
    );
};

export default GroupMembership;
